import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHelperService } from '../../services/TranslateService';
import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../dataServices/userService';
import { UserEmailConfirmationModel } from './welcome-page.model';
import { AzureLoggerService } from 'src/app/services/azureLoggerService';

@Component({
    selector: 'self-ins-welcome-page',
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.scss'],
    standalone: false
})
export class WelcomePageComponent {
    @ViewChild('form', { static: false }) public form: NgForm | undefined;
    public email: string = '';
    public password: string = '';
    public submitted = false;

    public constructor(private router: Router,
                       private activatedRoute: ActivatedRoute,
                       private toastrService: ToastrService,
                       private userStatusService: UserService,
                       private translateHelper: TranslateHelperService) 
    {}

    public onSubmit() {
        this.submitted = true;

        const userId = +this.activatedRoute.snapshot.queryParams['userId'];
        const token = this.activatedRoute.snapshot.queryParams['token'];

        // @ts-ignore
        if (!userId || !token || !this.form.valid) {
            this.router.navigate(['']);
        }

        const requestModel = {
            userId,
            token,
            password: this.password,
            email: this.email
        } as UserEmailConfirmationModel;

        this.userStatusService.confirmEmail(requestModel)
            .subscribe(
                () => {},
                (_error) => {
                    this.translateHelper.translateAsync(this.translateHelper.Keys.WELCOME_CONFIRM_EMAIL_ERROR).subscribe((message: string) => {
                        this.toastrService.error(message);
                    });
                    return;
                },
                () => {
                    this.translateHelper.translateAsync(this.translateHelper.Keys.WELCOME_CONFIRM_EMAIL_SUCCESS).subscribe((message: string) => {
                        this.toastrService.success(message);
                    });
                    this.router.navigate(['']);
                });
    }
}